module.exports = __webpack_public_path__ + "assets/img/20_964_big.0122aff3.jpg";